import React from "react";
import { useCart } from "../../contexts/CartContext";
import AddToList from "./AddToList";

function ResultsHeader({ results, pageNum }) {
  const { addItem, removeItem, containsAll } = useCart();
  const isSignedIn = !!window.UW211?.CURRENT_USER;

  if (!results || results.length === 0) return null;

  const allInCart = containsAll(results);

  function handleClick() {
    if (allInCart) {
      results.forEach((r) => removeItem(r));
    } else {
      results.forEach((r) => addItem(r));
    }
  }

  if (isSignedIn) {
    return (
      <div className="result-detail add-to-list-region results-header-actions">
        <AddToList results={results} pageNum={pageNum} />
      </div>
    );
  }

  return (
    <div className="result-detail add-to-cart-region cart-link-container results-header-actions">
      <div className="cart result-action small-label pointer" onClick={handleClick} role="button" tabIndex={0}>
        {allInCart ? "Remove Results from List" : "Add Results to List"}
      </div>
    </div>
  );
}

export default ResultsHeader;
